import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-mobile-jc3-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './mobile-jc3-banner.component.html',
    styleUrl: './mobile-jc3-banner.component.scss',
})
export class MobileJc3BannerComponent implements OnChanges {
    @Input() banners: any = {};
    mobileBanner = '';

    ngOnChanges(changes): void {
        if (changes?.banners) {
            let bn = changes?.banners?.currentValue;
            this.mobileBanner = bn?.bannermobile || bn?.bannerportrait;
        }
    }
}
